import Vue from 'vue'
import VideoBackground from 'vue-responsive-video-background-player'
Vue.component('video-background', VideoBackground)

const el = document.querySelector('#background-video-player')
if (el != null) {
  var vm = new Vue({
    components: {
      VideoBackground
    },
    data () {
      return {
        videoPaused: false
      }
    },
    methods: {
      playVideo () {
        this.$emit('ready')
        if (!this.current.autoplay) return
        this.$refs.videobackground.player.play()
      },
      playerState () {
        this.videoPaused = !this.videoPaused
        if (this.videoPaused) {
          this.$refs.videobackground.player.pause()
          this.videoPaused = true
        } else {
          this.$refs.videobackground.player.play()
          this.videoPaused = false
        }
      }
    }
  })
  vm.$mount(el)
}
